import type { HubEnrollmentDto } from "@niutraan/shared-dto";
import { create } from "zustand";

interface HubEnrollmentState {
  // State
  enrollments: HubEnrollmentDto[];
  userEnrollments: HubEnrollmentDto[];
  selectedEnrollment: HubEnrollmentDto | null;

  // Actions
  setEnrollments: (enrollments: HubEnrollmentDto[]) => void;
  setUserEnrollments: (enrollments: HubEnrollmentDto[]) => void;
  setSelectedEnrollment: (enrollment: HubEnrollmentDto | null) => void;

  // Reset state
  reset: () => void;
}

// Initial state
const initialState = {
  enrollments: [],
  userEnrollments: [],
  selectedEnrollment: null,
};

export const useHubEnrollmentStore = create<HubEnrollmentState>((set) => ({
  ...initialState,

  // Actions
  setEnrollments: (enrollments) => set({ enrollments }),
  setUserEnrollments: (userEnrollments) => set({ userEnrollments }),
  setSelectedEnrollment: (selectedEnrollment) => set({ selectedEnrollment }),

  // Reset state
  reset: () => set(initialState),
}));
